import { type MCPServerInfo } from '../../types';

const PrismaServer: MCPServerInfo = {
  serverId: 'PRISMA',
  name: 'Prisma',
  slug: 'prisma',
  description: 'Prisma Remote MCP Server',
  source: {
    sourceType: 'REMOTE_URL',
    mcpServerUrl: 'https://mcp.prisma.io/mcp'
  },
  authenticationType: 'OAUTH',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: [],
    properties: {}
  }
};

export default PrismaServer;
